import React, { useCallback, useRef, useState } from 'react';

export type ComboBoxInputFixedValueProps = {
  inputValue?: string;
  threshold?: number;
  thresholdSingleCharacterExceptions?: string[];
};

export function useComboBoxInputFixedValue() {
  const formInputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState<string>();

  /**
   * Clearing the Combobox Input by removing input + query and clearing all saved results.
   */
  const clearInput = useCallback(() => {
    setInputValue(undefined);
  }, []);

  /**
   * Changing characters on user input
   * deselecting current selection from listbox
   * resetting hidden input
   * */
  const onInput = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  }, []);

  return {
    inputValue,
    formInputRef,
    onInput,
    clearInput,
  };
}
